module.exports = __webpack_public_path__ + "static/media/website-templets-img-1.6023a243.png";